/* global axios */
import ApiClient from './ApiClient';

class FollowUpCadenceDefinitionsAPI extends ApiClient {
  constructor() {
    super('follow-up-cadence-definitions', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { follow_up_cadence_definition: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, {
      follow_up_cadence_definition: data,
    });
  }

  funnel(id) {
    return axios.get(`${this.url}/${id}/funnel`);
  }

  // Modelos prontos por área (FollowUpCadences::ModelosDeRegua). Existem para
  // que ninguém precise inventar uma régua do zero — e a régua inventada do
  // zero costuma ser a longa e espaçada que o mercado já provou que perde
  // cliente.
  modelos() {
    return axios.get(`${this.url}/modelos`);
  }

  criarDeModelo(area) {
    return axios.post(`${this.url}/criar_de_modelo`, { area });
  }

  overview(periodDays, { dailyFrom, dailyTo } = {}) {
    return axios.get(`${this.url}/overview`, {
      params: {
        period_days: periodDays,
        daily_from: dailyFrom,
        daily_to: dailyTo,
      },
    });
  }
}

export default new FollowUpCadenceDefinitionsAPI();
